<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading
                :active.sync="isLoading"
                :is-full-page="fullPage"
            ></loading>
        </div>

        <breadcrumb :page="$t('form.setting.createTuition')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert
                    v-model="alert"
                    :variant="alertClass"
                    dismissible
                    fade
                    >{{ alertMessage }}</b-alert
                >

                <div class="card">
                    <form role="form" @submit.prevent="saveTuitionFee()">
                        <div class="card-header bg-light">
                            <div class="card-title">
                                {{ $t("form.setting.createTuition") }}
                            </div>
                            <button class="btn btn-primary float-right">
                                {{ $t("button.save") }}
                            </button>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label for="ProgramType:">
                                            {{ $t("form.program.programType") }}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <div>
                                            <v-select
                                                :options="programTypes"
                                                v-model="tuitionFee.ProgramType"
                                                :reduce="
                                                    programTypes => programTypes
                                                "
                                            >
                                            </v-select>
                                            <div
                                                class="invalid-feedback"
                                                v-if="
                                                    !$v.tuitionFee.ProgramType
                                                        .required
                                                "
                                            ></div>
                                        </div>
                                        <div class="mt-3">
                                            <b-form-checkbox
                                                v-model="tuitionFee.status"
                                                @change="clear($event)"
                                            >
                                                Active
                                            </b-form-checkbox>
                                        </div>
                                        <div>
                                            <div class="form-group mt-3">
                                                <label>{{
                                                    $t(
                                                        "form.program.billingCycle"
                                                    )
                                                }}</label>
                                                <b-form-select
                                                    v-model="
                                                        tuitionFee.BillingCycle
                                                    "
                                                    :disabled="
                                                        tuitionFee.status ==
                                                            false ||
                                                            tuitionFee.ProgramType ==
                                                                null
                                                    "
                                                    :options="options"
                                                    @change="
                                                        changeBillingCycle()
                                                    "
                                                ></b-form-select>
                                            </div>
                                            <div
                                                class="form-group mt-5 mb-4 d-flex justify-content-between"
                                            >
                                                <label>{{
                                                    $t(
                                                        "form.program.issueInvoices"
                                                    )
                                                }}</label>
                                                <input
                                                    v-model="tuitionFee.days"
                                                    type="number"
                                                    min="1"
                                                    max="60"
                                                    class="form-control mx-2 col-xs-2"
                                                    :disabled="
                                                        tuitionFee.status ==
                                                            false ||
                                                            tuitionFee.ProgramType ==
                                                                null
                                                    "
                                                />
                                                <label>{{
                                                    $t("form.program.days")
                                                }}</label>
                                                <b-form-select
                                                    class="mx-2 col-xs-2"
                                                    v-model="
                                                        tuitionFee.beforeOrAfter
                                                    "
                                                    :options="
                                                        afterOrBeforeDropdown
                                                    "
                                                    :disabled="
                                                        tuitionFee.status ==
                                                            false ||
                                                            tuitionFee.ProgramType ==
                                                                null
                                                    "
                                                ></b-form-select>
                                                <label>{{
                                                    $t(
                                                        "form.program.cycleStartDate"
                                                    )
                                                }}</label>
                                            </div>
                                            <div
                                                class="form-group"
                                                v-if="
                                                    tuitionFee.BillingCycle ==
                                                        'course' &&
                                                        tuitionFee.ProgramType
                                                "
                                            >
                                                <label>{{
                                                    $t(
                                                        "form.program.noOfCourses"
                                                    )
                                                }}</label>
                                                <input
                                                    class="form-control"
                                                    v-model="
                                                        tuitionFee.noOfCourses
                                                    "
                                                    type="text"
                                                    @input="
                                                        handleNoOfCoursesInput(
                                                            $event.target.value
                                                        )
                                                    "
                                                    maxlength="2"
                                                    id="noOfCousesID"
                                                    name="number"
                                                    :disabled="
                                                        tuitionFee.status ==
                                                            false ||
                                                            tuitionFee.ProgramType ==
                                                                null
                                                    "
                                                />
                                            </div>
                                            <div
                                                class="form-group"
                                                v-if="
                                                    tuitionFee.BillingCycle ==
                                                        'course' &&
                                                        tuitionFee.ProgramType
                                                "
                                            >
                                                <label
                                                    >{{
                                                        $t(
                                                            "form.program.course"
                                                        )
                                                    }}
                                                    {{
                                                        $t("form.program.fee")
                                                    }}</label
                                                >
                                                <b-form-input
                                                    v-model.number="
                                                        tuitionFee.courseFee
                                                    "
                                                    :disabled="
                                                        tuitionFee.status ==
                                                            false ||
                                                            tuitionFee.ProgramType ==
                                                                null
                                                    "
                                                ></b-form-input>
                                            </div>
                                            <div
                                                class="form-group"
                                                v-if="
                                                    tuitionFee.BillingCycle ==
                                                        'term' &&
                                                        tuitionFee.ProgramType
                                                "
                                            >
                                                <label>{{
                                                    $t("form.program.noOfSem")
                                                }}</label>
                                                <input
                                                    class="form-control"
                                                    v-model.number="
                                                        tuitionFee.noOfSem
                                                    "
                                                    type="text"
                                                    @input="
                                                        handleInput(
                                                            $event.target.value
                                                        )
                                                    "
                                                    maxlength="2"
                                                    id="noOfSemID"
                                                    name="number"
                                                    :disabled="
                                                        tuitionFee.status ==
                                                            false ||
                                                            tuitionFee.ProgramType ==
                                                                null
                                                    "
                                                />
                                            </div>
                                            <template
                                                v-if="
                                                    tuitionFee.BillingCycle ==
                                                        'term' &&
                                                        tuitionFee.noOfSem >=
                                                            1 &&
                                                        tuitionFee.ProgramType
                                                "
                                            >
                                                <div
                                                    class="form-group"
                                                    v-for="semester in tuitionFee.noOfSem"
                                                    :key="semester"
                                                >
                                                    <label
                                                        >{{
                                                            $t(
                                                                "form.program.termFee"
                                                            )
                                                        }}{{ semester }}</label
                                                    >
                                                    <b-form-input
                                                        v-model.number="
                                                            tuitionFee
                                                                .semesterfees[
                                                                'semester' +
                                                                    semester +
                                                                    'Fee'
                                                            ]
                                                        "
                                                        :key="semester"
                                                        :value="semester"
                                                        :disabled="
                                                            tuitionFee.status ==
                                                                false ||
                                                                tuitionFee.ProgramType ==
                                                                    null
                                                        "
                                                    >
                                                    </b-form-input>
                                                </div>
                                            </template>
                                            <div class="form-group">
                                                <label>{{
                                                    $t(
                                                        "form.program.applicationFee"
                                                    )
                                                }}</label>
                                                <b-form-input
                                                    v-model.number="
                                                        tuitionFee.ApplicationFee
                                                    "
                                                    :disabled="
                                                        tuitionFee.status ==
                                                            false ||
                                                            tuitionFee.ProgramType ==
                                                                null
                                                    "
                                                ></b-form-input>
                                            </div>

                                            <div class="form-group">
                                                <label>{{
                                                    $t(
                                                        "form.program.acceptanceFee"
                                                    )
                                                }}</label>
                                                <b-form-input
                                                    v-model.number="
                                                        tuitionFee.AcceptanceFee
                                                    "
                                                    :disabled="
                                                        tuitionFee.status ==
                                                            false ||
                                                            tuitionFee.ProgramType ==
                                                                null
                                                    "
                                                ></b-form-input>
                                            </div>

                                            <hr />

                                            <div
                                                class="d-flex justify-content-between"
                                            >
                                                <label>{{
                                                    $t("form.program.totalCost")
                                                }}</label>
                                                <p>
                                                    {{
                                                        totalFee
                                                            | curreny(
                                                                decimalDigits,
                                                                decimalPoint,
                                                                thousandSeparator
                                                            )
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    required,
    minLength,
    maxLength,
    alpha,
    between
} from "vuelidate/lib/validators";

export default {
    props: [
        "permissions",
        "editFormInterval",
        "datetimeFormat",
        "applicationFee",
        "dateFormat",
        "decimalDigits",
        "decimalPoint",
        "thousandSeparator"
    ],

    data() {
        return {
            alert: false,
            alertClass: "",
            alertMessage: "",

            isLoading: false,
            fullPage: true,

            request_source: "",
            invalidProgramType: false,
            interval: "",
            currentPage: 1,

            billingCycleChanged: false,

            tuitionFee: {
                ProgramType: null,
                BillingCycle: null,
                ApplicationFee: 0,
                AcceptanceFee: 0,
                courseFee: 0,
                noOfSem: 0,
                noOfCourses: 0,
                status: false,
                days: null,
                beforeOrAfter: "before",
                semesterfees: {
                    semester1Fee: 0,
                    semester2Fee: 0,
                    semester3Fee: 0,
                    semester4Fee: 0,
                    semester5Fee: 0,
                    semester6Fee: 0,
                    semester7Fee: 0,
                    semester8Fee: 0,
                    semester9Fee: 0,
                    semester10Fee: 0,
                    semester11Fee: 0,
                    semester12Fee: 0,
                    semester13Fee: 0,
                    semester14Fee: 0,
                    semester15Fee: 0,
                    semester16Fee: 0,
                    semester17Fee: 0,
                    semester18Fee: 0,
                    semester19Fee: 0,
                    semester20Fee: 0
                },
                total: 0,
                sem_total: 0
            },
            max_semesters: 20,
            options: [
                { value: "term", text: this.$t("form.program.byTerm") },
                { value: "course", text: this.$t("form.program.byCourse") }
            ],
            afterOrBeforeDropdown: [
                {
                    text: this.$t("form.program.before"),
                    value: "before"
                },
                {
                    text: this.$t("form.program.after"),
                    value: "after"
                }
            ],
            programTypes: []
        };
    },
    validations: {
        tuitionFee: {
            ProgramType: {
                required
            }
        }
    },
    watch: {
        "tuitionFee.semesterfees": {
            handler: function(val, oldVal) {
                var addtototal = 0;
                for (var v in val) {
                    addtototal += Number(val[v]);
                }
                this.tuitionFee.sem_total = addtototal;
            },
            deep: true
        }
    },
    mounted() {
        if (!this.permissions.createSettingsTuitionfee) {
            this.$router.push("/");
            return;
        }

        this.initialData();
    },

    computed: {
        totalFee() {
            if (this.billingCycleChanged == true) return false;
            let total = 0;
            let application_fee = parseFloat(this.tuitionFee.ApplicationFee);
            let acceptance_fee = parseFloat(this.tuitionFee.AcceptanceFee);
            let no_of_courses = parseFloat(this.tuitionFee.noOfCourses);
            let courseFee = parseFloat(this.tuitionFee.courseFee);
            if (courseFee == "" || courseFee == NaN || courseFee == null) {
                courseFee = 0;
            }
            if (
                no_of_courses == "" ||
                no_of_courses == NaN ||
                no_of_courses == null
            ) {
                no_of_courses = 1;
            }

            if (courseFee) total += courseFee;

            if (no_of_courses && courseFee)
                total += courseFee * Number(no_of_courses) - courseFee;

            // Application Fee Add
            if (
                application_fee == "" ||
                application_fee == NaN ||
                application_fee == null
            ) {
                application_fee = 0;
            }
            if (application_fee) total += application_fee;

            // Administration Fee Add
            if (
                acceptance_fee == "" ||
                acceptance_fee == NaN ||
                acceptance_fee == null
            ) {
                acceptance_fee = 0;
            }
            if (acceptance_fee) total += acceptance_fee;

            //tuitionFee
            if (this.tuitionFee.sem_total) total += this.tuitionFee.sem_total;
            if (total != "" && total != undefined && total != null) {
                total = Number(total);
                this.tuitionFee.total = total;
                return total.toFixed(2);
            }
            return 0;
        },
        readonly() {
            return !this.permissions.editSettingsTuitionfee;
        }
    },

    methods: {
        changeBillingCycle() {
            this.tuitionFee.courseFee = 0;
            this.tuitionFee.noOfSem = 0;
            this.tuitionFee.noOfCourses = 0;
            for (var i = 1; i <= this.max_semesters; i++) {
                this.tuitionFee.semesterfees["semester" + i + "Fee"] = null;
            }
        },
        initialData() {
            axios
                .get("/api/programs/initial-data")
                .then(({ data }) => {
                    this.programTypes = data.program_types;
                    this.perPageAudits = data.auditsPaginate;
                })
                .catch(error => console.log("error fetching initial data"));
        },
        handleInput(value) {
            value = value.replace(/^0+(?!\.|$)/, "");
            if (value != "" && !(Number(value) >= 1 && Number(value) <= 20)) {
                alert("just numbers between 1 to 20 are allowed");
                this.tuitionFee.noOfSem = "";
            } else {
                this.tuitionFee.noOfSem = value == "" ? value : Number(value);
            }
        },
        handleNoOfCoursesInput(value) {
            value = value.replace(/^0+/, "");
            this.tuitionFee.noOfCourses = value == "" ? value : Number(value);
            if (value != "" && !(Number(value) >= 1 && Number(value) <= 30)) {
                alert("just numbers between 1 to 30 are allowed");
                this.tuitionFee.noOfCourses = "";
            } else {
                this.tuitionFee.noOfCourses =
                    value == "" ? value : Number(value);
            }
        },

        clear(value) {
            if (
                value == true &&
                (this.tuitionFee.ProgramType == null ||
                    this.tuitionFee.ProgramType == "")
            ) {
                alert("choose program type to create it");
                this.tuitionFee.status = false;
            }
            if (this.tuitionFee.ProgramType != null && value == false) {
                (this.tuitionFee.BillingCycle = null),
                    (this.tuitionFee.ApplicationFee = null),
                    (this.tuitionFee.AcceptanceFee = null),
                    (this.tuitionFee.noOfSem = null),
                    (this.tuitionFee.noOfCourses = null),
                    (this.tuitionFee.courseFee = 0);
                for (var i = 1; i <= this.max_semesters; i++) {
                    this.tuitionFee.semesterfees["semester" + i + "Fee"] = null;
                }
                (this.tuitionFee.total = 0), (this.billingCycleChanged = false);
            }
        },
        saveTuitionFee() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                let errorMsg = "";
                if (this.$v.tuitionFee.ProgramType.$error) {
                    errorMsg = "Program Type";
                }

                this.showAlert(
                    this.$t("form.validation.mandatoryFieldsError", {
                        errors: errorMsg
                    }),
                    "danger"
                );
                return;
            }

            for (var i = 1; i <= this.max_semesters; i++) {
                if (
                    this.tuitionFee.noOfSem < i &&
                    (this.tuitionFee.semesterfees["semester" + i + "Fee"] ==
                        "" ||
                        this.tuitionFee.semesterfees["semester" + i + "Fee"] ==
                            NaN ||
                        this.tuitionFee.semesterfees["semester" + i + "Fee"] ==
                            0)
                ) {
                    this.tuitionFee.semesterfees["semester" + i + "Fee"] = null;
                }
            }
            if (
                this.tuitionFee.courseFee == 0 ||
                this.tuitionFee.courseFee == NaN
            ) {
                this.tuitionFee.courseFee = null;
            }
            if (
                this.tuitionFee.noOfSem == 0 ||
                this.tuitionFee.noOfSem == NaN
            ) {
                this.tuitionFee.noOfSem = null;
            }
            this.isLoading = true;
            // let formData = new FormData();
            // formData.append("tuition_fee", JSON.stringify(this.tuitionFee));
            Array.from(this.tuitionFee.semesterfees).forEach(semester =>
                formData.append("semesterfees", JSON.stringify(semester))
            );
            this.tuitionFee.total = this.totalFee;
            if (
                typeof this.tuitionFee.noOfCourses === "string" ||
                this.tuitionFee.noOfCourses instanceof String
            ) {
                this.tuitionFee.noOfCourses = Number(
                    this.tuitionFee.noOfCourses
                );
            }

            axios
                .post("/api/tuitionfees", this.tuitionFee)
                .then(response => {
                    this.isLoading = false;

                    if (response.data.message) {
                        this.showAlert(response.data.message);

                        setTimeout(() => {
                            this.$router
                                .push({
                                    name: "TuitionFee"
                                })
                                .catch(error => {
                                    console.info(error.message);
                                });
                        }, 2000);
                    }
                })
                .catch(error => {
                    this.isLoading = false;

                    if (error.response.data) {
                        this.showAlert(error.response.data.message, "danger");
                    }
                });
        },

        paginate() {
            this.getAudits();
        },

        showAlert(msg, cls = "success") {
            this.alertMessage = msg;
            this.alertClass = cls;
            this.alert = true;
        }
    },

    beforeRouteLeave(to, from, next) {
        if (this.closing) next();
        else {
            const answer = window.confirm(this.$t("leavePrompt"));

            if (answer) {
                next();
            } else {
                next(false);
            }
        }
    }
};
</script>

<style scoped>
.custom-validate {
    display: block !important;
}
</style>
